import { MarkAsSeen } from "@/api/contactUs";
import { useState, useEffect } from "react";
import { CardBase } from "./Utils/CardHelper";
import { TopicButton } from "./Utils/TopicButton";
import { ContactFormState } from "@/interfaces/contactUs_type";

export type ContactUsCardProps = {
    contactUs: ContactFormState,
    isNew: boolean,
    onView: () => void
}
export function ContactUsCard({ contactUs, isNew, onView }: ContactUsCardProps) {
    const [isNewLocal, setIsNewLocal] = useState(isNew);
    const [disabled, setDisabled] = useState(false);

    useEffect(() => {
        if (isNewLocal) {
            setIsNewLocal(true);
            onView();
        }
    }, [isNewLocal, onView]);

    const handleMark = async () => {
        const response = await MarkAsSeen(contactUs.email);
        if (response.operation === "COMPLETED") {
            setIsNewLocal(false);
            setDisabled(true);
        }
    };

    return (
        <div className={`${disabled ? 'hidden' : ''}`}>
            <CardBase
                isNew={isNewLocal}
                canOpen={false}
            >
                <div className="flex flex-col justify-center">
                    <h3>{contactUs.email}</h3>
                </div>
                <div className="flex flex-row">
                    {contactUs.general && <TopicButton topic="General Inquiry" color="bg-orange-100 dark:bg-orange-900" />}
                    {contactUs.pricing && <TopicButton topic="Pricing" color="bg-green-100 dark:bg-green-900" />}
                    {contactUs.services && <TopicButton topic="Services" color="bg-red-100 dark:bg-red-900" />}
                </div>

                <button
                    onClick={() => handleMark()}
                    className="p-2 my-2 text-white transition-colors duration-300 bg-red-400 rounded-md hover:bg-red-500 dark:bg-red-900 dark:hover:bg-red-800"
                > Mark as seen</button>
            </CardBase>
        </div>
    );
}
